/**
 * The M1NT credit balance lives on the server (GET /users/me/mint-credits). The user object saved in
 * the session does not carry it, so every place that shows the balance reads the endpoint. Pages that
 * already fetched a fresh balance announce it here so the header does not wait for its own refresh.
 */
export const MINT_CREDITS_EVENT = 'mintCreditsUpdated'

export function announceMintCredits(balance) {
  const value = Number(balance)
  if (!Number.isFinite(value)) return
  window.dispatchEvent(new CustomEvent(MINT_CREDITS_EVENT, { detail: { balance: value } }))
}
